// Dependencies
//import axios from 'axios';
import 'whatwg-fetch';

// Utils
import { logToConsole } from './log';


export function apiFetch(
  endpoint = process.env.REACT_APP_IP_LOCATION_API_URL,
  options = {}
) {
  const fetchOptions = apiOptions(options);
  const fetchEndpoint = endpoint;

  logToConsole('Endpoint: ', fetchEndpoint, 'Options: ', fetchOptions);

  return fetch(fetchEndpoint, fetchOptions).then(response => response.json());
}

export function apiOptions(options = {}) {
  const {
    method = 'GET',
    headers = {
      'Content-Type': 'application/json'
    },
    body = false
  } = options;

  const newOptions = {
    method,
    headers //, credentials: 'include'
  };

  if (body) {
    // For login endpoint
    newOptions.body = JSON.stringify(body);
  }

  return newOptions;
}
